import React from "react";
import SectionView from "../../../../Common/Views/SectionView";
import 'firebase/firestore';
import FeaturedLinksPageController from "./FeaturedLinksPageController";

export const FeaturedLinksSection = () => {

    return(
            <SectionView title={'Featured Links'}>
                <FeaturedLinksPageController />
            </SectionView>
    );
};
